import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import LoaderGif from "../assets/Loader.gif";

const getStep = (progress) => {
  if (progress < 5) {
    return {
      pct: `${progress}%`,
      label: "Processing",
      msg: "Hold on… we’re preparing your Gemstone Report",
    };
  }

  if (progress < 50) {
    return {
      pct: `${progress}%`,
      label: "In progress",
      msg: "Analyzing your planetary positions and dasha influence to understand your life path.",
    };
  }

  if (progress < 90) {
    return {
      pct: `${progress}%`,
      label: "Almost done",
      msg: "💎 Finalizing Your Perfect Gemstone Recommendation Based on Your Chart Insights",
    };
  }

  return {
    pct: "100%",
    label: "Completed",
    msg: "💎 Finalizing Your Perfect Gemstone Recommendation Based on Your Chart Insights",
  };
};

function GemstoneProgress({ progress }) {
  const { pct, label, msg } = getStep(progress);
  return (
    <div className="progress-center-box">
      <div className="progress-card">
        <img src={LoaderGif} alt="Loading" className="gemstone-loader-gif" />
        <div style={{ marginTop: "120px" }}>
          <div style={{ fontWeight: 600, textAlign: "center" }}>
            {pct}{" "}
            <span className="pct-label-text">{label}</span>
          </div>
          <div className="progress-bar-outer">
            <div className="progress-bar-inner" style={{ width: pct }} />
          </div>
        </div>
        <div className="progress-msg" style={{ marginTop: "28px" }}>
          {msg}
        </div>
      </div>
    </div>
  );
}

export default GemstoneProgress;
